import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#E65081',
        secondary: '#999999',
        accent: '#F7F9F9',
        white: '#ffffff',
        error: '#E74C3C',
        warning: '#F39C12',
        success: '#16A085',
        loading: 'blue'
      }
    }
  }
}
export default new Vuetify(opts)
